module.exports = __webpack_public_path__ + "static/media/Walsheim-Bold.60401ca2.ttf";